export const createContact = (contact) => {
  const contactTitle = document.querySelector('[data-contact-title]');
  const contactImage = document.querySelector('[data-contact-image]');

  contactTitle.innerText = contact.title;
  contactImage.setAttribute('data-src', contact.image)
}